import type { TFunction } from 'i18next';
import type { ProjectedPaymentsForm } from './index';

const isEmpty = (value: unknown): boolean => value === undefined || value === null || value === '';

const isInvalidNumber = (value: unknown): boolean => {
  if (isEmpty(value)) return false;
  const number = Number(value);
  return !Number.isFinite(number) || number < 0;
};

// Returns the first validation message for the form, or null when it can be saved.
export const getProjectedPaymentsError = (
  values: ProjectedPaymentsForm,
  t: TFunction,
): string | null => {
  const yearRanges = values.year_ranges || [];
  const numericFields = [
    values.prorations_amount,
    ...yearRanges.flatMap((yearRange) => [...(yearRange.range || []), yearRange.amount]),
  ];
  if (values.principal_kind === 'range') {
    numericFields.push(values.principal_min, values.principal_max);
  }
  if (numericFields.some(isInvalidNumber)) {
    return t('projectedPayments:invalidNumber');
  }

  const hasInvalidRange = (min: unknown, max: unknown): boolean => (
    !isEmpty(max) && Number(max) > 0 && Number(min) > Number(max)
  );
  const rangesOutOfOrder = yearRanges.some(
    (yearRange) => hasInvalidRange(yearRange.range?.[0], yearRange.range?.[1]),
  );
  if (rangesOutOfOrder || (values.principal_kind === 'range' && hasInvalidRange(values.principal_min, values.principal_max))) {
    return t('projectedPayments:minGreaterThanMax');
  }

  return null;
};
